// extracted by mini-css-extract-plugin
export default {"overlay":"ny-z","bodyOpen":"oy-z","content":"py-z","header":"qy-z","close":"ry-z","closeNoHeading":"sy-z"};